import { withRouter } from '../../utils/withRouter';
import ResetPassword from './resetPassword';

export default withRouter(ResetPassword);
